<template>
  <div class="about">
    <h1>新闻</h1>
  </div>
</template>
